var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainHubIconLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#333132;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#2CC2E0;}\n\t.st3{fill:#F7941D;}\n\t.st4{fill:#8DC63F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_1889"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3572",
    className: "st0",
    d: "M100,200c55.2,0,100-44.8,100-100S155.2,0,100,0S0,44.8,0,100S44.8,200,100,200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3573",
    className: "st1",
    d: "M100,170.5c38.9,0,70.5-31.6,70.5-70.5S138.9,29.5,100,29.5c-38.9,0-70.5,31.5-70.5,70.5 C29.5,138.9,61.1,170.5,100,170.5C100,170.5,100,170.5,100,170.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3574",
    className: "st2",
    d: "M100,176.7c-42.4,0-76.7-34.4-76.7-76.7S57.6,23.3,100,23.3s76.7,34.4,76.7,76.7l0,0 C176.7,142.4,142.4,176.7,100,176.7 M100,35.8c-35.5,0-64.2,28.7-64.2,64.2s28.7,64.2,64.2,64.2s64.2-28.7,64.2-64.2l0,0 C164.2,64.6,135.4,35.8,100,35.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3575",
    className: "st3",
    d: "M116.8,104.4h8.3c1.5,0,2.7,1.2,2.7,2.7v8.2c0,1.5-1.2,2.7-2.7,2.7h-8.3 c-1.5,0-2.7-1.2-2.7-2.7v-8.2C114.1,105.7,115.3,104.4,116.8,104.4 M83.2,118h-8.3c-1.5,0-2.7-1.2-2.7-2.7c0,0,0,0,0,0v-8.2 c0-1.5,1.2-2.7,2.7-2.7h8.3c1.5,0,2.7,1.2,2.7,2.7c0,0,0,0,0,0v8.2C85.9,116.8,84.7,118,83.2,118 M65.2,101.2v28.2 c0,2.3,1.8,4.1,4.1,4.1H89c2.3,0,4.1-1.8,4.1-4.1c0,0,0,0,0,0v-20.9c0-2.3,1.8-4.1,4.1-4.1h5.6c2.3,0,4.1,1.8,4.1,4.1v20.9 c0,2.3,1.8,4.1,4.1,4.1c0,0,0,0,0,0h19.7c2.3,0,4.1-1.8,4.1-4.1c0,0,0,0,0,0v-28.2c0-1.1-0.5-2.2-1.3-3L102.8,70 c-1.6-1.4-4-1.4-5.5,0L66.5,98.2C65.7,99,65.2,100.1,65.2,101.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3576",
    className: "st3",
    d: "M127.9,81V64.6c0-2.3-1.8-4.1-4.1-4.1h-1.4c-2.3,0-4.1,1.8-4.1,4.1v7.5l-11.3-10.4 c-3.9-3.6-9.9-3.6-13.8,0l-39,35.8c-0.9,0.9-1,2.4-0.1,3.3c0.9,0.9,2.3,1,3.3,0.1l38.4-35.3c2.4-2.2,6.2-2.2,8.6,0l38.3,35.3 c1,0.9,2.4,0.8,3.3-0.2c0.9-0.9,0.8-2.4-0.1-3.3L127.9,81z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3577",
    className: "st4",
    d: "M100,194.9c-52.4,0-94.9-42.5-94.9-94.9c0-25.2,10-49.3,27.8-67.1c2.8-2.6,7.1-2.5,9.8,0.3 c2.5,2.7,2.5,6.8,0,9.4c-31.7,31.7-31.7,83.1,0,114.8s83.1,31.7,114.8,0s31.7-83.1,0-114.8c-15.2-15.2-35.9-23.8-57.4-23.8 c-3.8,0.1-7-2.8-7.1-6.6s2.8-7,6.6-7.1c0.2,0,0.3,0,0.5,0c52.4,0,95,42.5,95,94.9S152.5,194.9,100,194.9 C100,194.9,100,194.9,100,194.9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainHubIconLarge);
export default __webpack_public_path__ + "static/media/Main_Hub_Icon_Large.03530945f1343572eb4f1d8642013034.svg";
export { ForwardRef as ReactComponent };